module.exports = __webpack_public_path__ + "static/media/37.fe2df438.jpg";